//@ts-check
import { useContext } from 'react';
import { OrContext } from "../../components/or/OrContext";

export const useCaseData = () => {
    const orContext = useContext(OrContext);
    return orContext.caseData;
}